import { useCurrentUser } from '@qualio/ui-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { createSearchParams, useNavigate } from 'react-router-dom';
import { isBasicUserInAccount } from '../../../../../util/CurrentUser';
import { FOR_TRAINING_STATUS } from '../../../DocumentWorkspace/types';
import { WorkspaceTabs as WorkspaceTabsV2 } from '../../../DocumentWorkspace/WorkspaceV2/WorkspaceV2';

export const useNavigateAfterTraining = () => {
  const currentUser = useCurrentUser();
  const navigate = useNavigate();
  const { navigateToDashboardAfterTraining } = useFlags();
  const isBasicUser = isBasicUserInAccount(currentUser);
  const pathname = isBasicUser
    ? '/library'
    : `/workspace/${WorkspaceTabsV2.YOUR_ACTIONS}`;
  const search = isBasicUser
    ? ''
    : createSearchParams({
        action: FOR_TRAINING_STATUS,
      }).toString();

  return () => {
    if (navigateToDashboardAfterTraining) {
      window.location.replace('/');
      return;
    }
    void navigate({
      pathname,
      search,
    });
  };
};
